export { TextInput } from "@mantine/core";
export type { TextInputProps } from "@mantine/core";
export { textInputOverrides } from "./TextInput.config";
